import * as ReportApi from '~/Api/Report';
export var DecimalFormatter = Intl.NumberFormat(['cs-CZ'], {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
    useGrouping: false,
});
export var toUserFormat = function (dataType, value) {
    if (dataType === ReportApi.DataType.decimal) {
        return DecimalFormatter.format(Number(value));
    }
    return value;
};
export var fromUserFormat = function (dataType, value) {
    if (dataType === ReportApi.DataType.decimal) {
        return value.replace(',', '.');
    }
    return value;
};
export var validateFormat = function (dataType, value) {
    if (dataType === ReportApi.DataType.decimal) {
        return isNaN(Number(value));
    }
    return false;
};
